import { createTheme } from "@mui/material"
//import { blue, cyan } from "@mui/material/colors"
import { responsiveFontSizes } from "@mui/material/styles"
//import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';

const breakpoints = {
    values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
    }
}

let theme = createTheme({ 
    breakpoints,
    
    typography: {
        
        "fontFamily": `"Roboto", "Helvetica", "Arial", sans-serif`,
        "fontWeightLight": 300,
        "fontWeightRegular": 400,
        "fontWeightMedium": 500,
        h3: {
            [`@media screen and (max-width: ${breakpoints.values.sm}px)`]: { 
                
                fontSize: "1.3rem",
                fontWeight: 500,
                fontFamily: "Roboto,Helvetica,Arial,Lucida,sans-serif"
            }
        },
        p: {
            fontFamily: 'system-ui'
        },
    },
    palette: {
        background: {
            default: '#ffffff',
            paper: '#f7f6f3'
        }
    },
})

theme = responsiveFontSizes(theme)

export { theme }


// export const LightTheme = createTheme({
//     palette: {
//         primary: {
//            main: blue[700],
//            dark: blue[800],
//            light: blue[500],
//            contrastText: '#ffffff',
//         },
//         secondary: {
//             main: cyan[500],
//             dark: cyan[400],
//             light: cyan[300],
//             contrastText: '#ffffff',
//         },
//         background: {
//             default: '#ffffff',
//             paper: '#f7f6f3',
//         }
//     }
// }) 